export enum FolderField {
  id = 'id',
  name = 'name',
  createdAt = 'createdAt',
  builtIn = 'builtIn',

  // deleted = 'deleted',
  parentId = 'parentId',
  parentName = 'parentName',
  legalEntities = 'legalEntities',

  // organizationId = 'organizationId',
  type = 'type',
  typeLabel = 'typeLabel',
  status = 'status'
}
